import PropTypes from "prop-types";

export default function NumberInput({
  label,
  onChange,
  defaultValue,
  min = 0,
  max = 100,
  step = 1,
}) {
  const htmlId = label.replace(/\s+/g, "") + "Input";

  return (
    <div className="d-flex justify-content-end">
      <div className="form-check form-switch d-flex align-items-center">
        <label className="form-check-label text-muted me-3" htmlFor={htmlId}>
          {label}
        </label>
        <input
          className="form-control"
          type="number"
          id={htmlId}
          defaultValue={defaultValue}
          onChange={(e) => onChange(Number(e.target.value))}
          min={min}
          max={max}
          step={step}
          style={{
            width: 100,
            minWidth: 100,
            maxWidth: 100,
            textAlign: "right",
            boxSizing: "border-box",
          }}
        />
      </div>
    </div>
  );
}

NumberInput.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};
